import axios from 'axios';
import config from '../config/api.config';

const BASE_URL = `${config.apiUrl}/`;

export default axios.create({
  headers: { 'Content-Type': 'application/json' },
  baseURL: BASE_URL
});
